import React from 'react';
import { Input, Tooltip } from 'antd';
import { t } from '../../../i18n';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../utils/languageUtils';

interface InputFilterItemProps {
    label: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    inputClassName?: string;
    inputStyle?: React.CSSProperties;
}

const InputFilterItem: React.FC<InputFilterItemProps> = ({ 
    label, 
    value, 
    onChange, 
    className,
    spanClassName,
    disabled,
    required = false,
    placeholder
    ,
    inputClassName,
    inputStyle
}) => {
    // 使用统一的样式 Hook，根据语言自动返回合适的样式类名
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();
    const singleLineInputHeightClassName = [
        '[&_.ant-input-affix-wrapper]:!h-8',
        '[&_.ant-input-affix-wrapper]:!py-0',
        '[&_.ant-input-affix-wrapper>input]:!h-8',
        '[&_.ant-input-affix-wrapper>input]:!leading-8',
        '[&_.ant-input]:!h-8',
        '[&_.ant-input]:!leading-8'
    ].join(' ');
    
    // 如果 placeholder 是 undefined，使用默认值；如果是空字符串，则不显示 placeholder
    const inputPlaceholder = placeholder === undefined ? t('components.input.typeIn') : placeholder;
    
    // 在禁用状态下，如果内容不为空，使用 Tooltip 显示完整内容
    const inputElement = (
        <Input 
            placeholder={inputPlaceholder}
            value={value}
            allowClear
            onChange={onChange}
            disabled={disabled}
            size="middle"
            className={`w-full ${inputClassName || ''}`.trim()}
            style={inputStyle}
        />
    );
    
    // 当禁用且内容不为空时，用 div 包裹并用 Tooltip 包裹，确保 Tooltip 在 disabled 状态下也能工作
    const wrappedInput = disabled && value && value.trim() ? (
        <Tooltip title={value} placement="topLeft">
            <div style={{ display: 'inline-block', width: '100%' }}>
                {inputElement}
            </div>
        </Tooltip>
    ) : inputElement;
    
    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {required && <span style={{ color: '#ff4d4f', marginRight: '4px' }}>*</span>}
                {label}
            </span>
            <div className={`${inputContainerClassName} ${singleLineInputHeightClassName}`.trim()}>
                {wrappedInput}
            </div>
        </div>
    );
};

export default InputFilterItem; 